const key = "da97619fa73c78e5640b0d78dd55392d";

const requests =  {
    fetchLatest: `https://api.themoviedb.org/3/movie/latest?api_key=${key}&language=en-US`,

    fetchTopRated:`https://api.themoviedb.org/3/movie/top_rated?api_key=${key}&language=en-US&page=1` ,

    fetchUpcoming: `https://api.themoviedb.org/3/movie/upcoming?api_key=${key}&language=en-US&page=1`,

    fetchPopular:`https://api.themoviedb.org/3/movie/popular?api_key=${key}&language=en-US&page=1` ,

    fetchNowPlaying:`https://api.themoviedb.org/3/movie/now_playing?api_key=${key}&language=en-US&page=1`
    


};
export default requests;



// https://api.themoviedb.org/3/movie/popular?api_key=da97619fa73c78e5640b0d78dd55392d&language=en-US&page=1